<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>Clasificación</span>
  <span class="spacer"></span>
  @if (liveMatches && liveMatches.length > 0) {
    <span class="live-indicator">
      <span class="pulse-dot"></span>EN DIRECTO
    </span>
  }
  <button mat-icon-button (click)="reload()">
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>

<div class="group-bar">
  <div class="group-bar-scroll">
    <button
      type="button"
      class="group-chip"
      [class.active]="groupSelected === 'general'"
      (click)="selectGroup('general')"
    >
      🌍 General
    </button>
    @for (group of groups; track group) {
      <button
        type="button"
        class="group-chip"
        [class.active]="groupSelected === group._id"
        (click)="selectGroup(group._id)"
      >
        {{ group.name }}
      </button>
    }
  </div>
</div>

<div class="standings-page">
  @if (liveMatches && liveMatches.length > 0) {
    <section class="live-section">
      <div class="section-label">
        <span class="pulse-dot"></span>Partidos en juego
      </div>
      @for (match of liveMatches; track match) {
        <div class="live-card">
          <div class="live-scoreboard">
            <div class="live-team">
              <img class="live-flag" src="{{ match.homeTeam.flag }}" />
              <span class="live-goals">{{ match.homeGoals }}</span>
            </div>
            <span class="live-sep">:</span>
            <div class="live-team live-team--away">
              <span class="live-goals">{{ match.awayGoals }}</span>
              <img class="live-flag" src="{{ match.awayTeam.flag }}" />
            </div>
          </div>
          <div class="live-stats">
            <button
              type="button"
              class="live-stat"
              (click)="
                showUsers(
                  match.stats.homeWinUsers,
                  'Gana ' + match.homeTeam.name
                )
              "
            >
              <span class="live-stat-val">{{ match.stats?.homeWin }}</span>
              <span class="live-stat-lbl">1</span>
            </button>
            <button
              type="button"
              class="live-stat"
              (click)="showUsers(match.stats.drawUsers, 'Empate')"
            >
              <span class="live-stat-val">{{ match.stats?.draw }}</span>
              <span class="live-stat-lbl">X</span>
            </button>
            <button
              type="button"
              class="live-stat"
              (click)="
                showUsers(
                  match.stats.awayWinUsers,
                  'Gana ' + match.awayTeam.name
                )
              "
            >
              <span class="live-stat-val">{{ match.stats?.awayWin }}</span>
              <span class="live-stat-lbl">2</span>
            </button>
            <button
              type="button"
              class="live-stat live-stat--joker"
              (click)="showUsers(match.stats.jokersUsers, 'Usan comodín')"
            >
              <span class="live-stat-val">{{ match.stats?.jokers }}</span>
              <img src="/assets/imgs/joker-on.svg" />
            </button>
          </div>
          <div class="my-pred">
            <span>Mi pronóstico:</span>
            <strong
              >{{ match.userHomeGoals }} – {{ match.userAwayGoals }}</strong
            >
            @if (match.useJoker) {
              <img src="/assets/imgs/joker-on.svg" class="pred-joker" />
            }
          </div>
        </div>
      }
    </section>
  }

  @if (standings && standings.length >= 3) {
    <div class="podium">
      <div
        class="podium-card silver"
        [class.is-me]="standings[1].user._id == loggedUser._id"
        (click)="selectUser(standings[1].user)"
      >
        @if (
          currentTimestamp >= firstRoundIniTimestamp && standings[1].user.team
        ) {
          <div
            class="podium-champ-bg"
            [ngStyle]="{
              'background-image': standings[1].user.team.flag | asUrl,
            }"
          ></div>
        }
        <div class="podium-medal">🥈</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[1].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[1].user.name }}</div>
        <div class="podium-pts">
          {{ standings[1].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[1].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[1].user.pichichi
        ) {
          <div class="podium-pichichi">⚽ {{ standings[1].user.pichichi }}</div>
        }
        @if (standings[1].currentResults) {
          <div class="podium-live">
            @for (r of standings[1].currentResults; track r) {
              <span
                >{{ r.homeGoals }}-{{ r.awayGoals }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>

      <div
        class="podium-card gold first"
        [class.is-me]="standings[0].user._id == loggedUser._id"
        (click)="selectUser(standings[0].user)"
      >
        @if (
          currentTimestamp >= firstRoundIniTimestamp && standings[0].user.team
        ) {
          <div
            class="podium-champ-bg"
            [ngStyle]="{
              'background-image': standings[0].user.team.flag | asUrl,
            }"
          ></div>
        }
        <div class="podium-crown">👑</div>
        <div class="podium-medal">🥇</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[0].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[0].user.name }}</div>
        <div class="podium-pts">
          {{ standings[0].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[0].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[0].user.pichichi
        ) {
          <div class="podium-pichichi">⚽ {{ standings[0].user.pichichi }}</div>
        }
        @if (standings[0].currentResults) {
          <div class="podium-live">
            @for (r of standings[0].currentResults; track r) {
              <span
                >{{ r.homeGoals }}-{{ r.awayGoals }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>

      <div
        class="podium-card bronze"
        [class.is-me]="standings[2].user._id == loggedUser._id"
        (click)="selectUser(standings[2].user)"
      >
        @if (
          currentTimestamp >= firstRoundIniTimestamp && standings[2].user.team
        ) {
          <div
            class="podium-champ-bg"
            [ngStyle]="{
              'background-image': standings[2].user.team.flag | asUrl,
            }"
          ></div>
        }
        <div class="podium-medal">🥉</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[2].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[2].user.name }}</div>
        <div class="podium-pts">
          {{ standings[2].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[2].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[2].user.pichichi
        ) {
          <div class="podium-pichichi">⚽ {{ standings[2].user.pichichi }}</div>
        }
        @if (standings[2].currentResults) {
          <div class="podium-live">
            @for (r of standings[2].currentResults; track r) {
              <span
                >{{ r.homeGoals }}-{{ r.awayGoals }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>
    </div>
  }

  <div class="st-list">
    @for (standing of standings; track standing; let i = $index) {
      @if (standings.length < 3 || i >= 3) {
        <div
          class="st-row"
          id="standings-{{ standing.user._id }}"
          (click)="selectUser(standing.user)"
          [class.is-me]="standing.user._id == loggedUser._id"
        >
          @if (
            currentTimestamp >= firstRoundIniTimestamp && standing.user.team
          ) {
            <div
              class="champ-bg"
              [ngStyle]="{
                'background-image': standing.user.team.flag | asUrl,
              }"
            ></div>
          }
          <div class="st-rank">{{ i + 1 }}</div>
          <div class="st-avatar-wrap">
            <app-avatar [user]="standing.user"></app-avatar>
          </div>
          <div class="st-info">
            <span class="st-name">{{ standing.user.name }}</span>
            <div class="st-meta">
              @if (
                currentTimestamp >= firstRoundIniTimestamp &&
                standing.user.pichichi
              ) {
                <span class="st-pichichi">⚽ {{ standing.user.pichichi }}</span>
              }
              @if (standing.currentResults) {
                @for (lr of standing.currentResults; track lr) {
                  <span class="st-live-result">
                    {{ lr.homeGoals }}-{{ lr.awayGoals }}
                    @if (lr.useJoker) {
                      <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                    }
                  </span>
                }
              }
            </div>
          </div>
          <div class="st-change">
            <div
              class="change-arrow"
              [class.equal]="standing.posChange.change === 'equal'"
              [class.up]="standing.posChange.change === 'up'"
              [class.down]="standing.posChange.change === 'down'"
            ></div>
            <span class="change-num">{{ standing.posChange.number }}</span>
          </div>
          <div class="st-pts-col">
            <div class="st-pts">{{ standing.points }}</div>
            <div class="st-jokers">
              {{ standing.jokersConsumed
              }}<img src="/assets/imgs/joker-on.svg" />
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>

<block-ui></block-ui>
